<template>
  <div class="timepicker-element">
    <span
      v-if="isShown('hh')"
      class="timepicker-element__underlined"
    >
      <input
        v-model="Data.hh"
        type="number"
        placeholder="hh"
        title="hours"
        @click="selectAll"
        @change="evaluate({pointer: 'hh', min: Data.hhMin, max: Data.hhMax})"
      >
      <span>h</span>
    </span>
    <span
      v-if="isShown('mm')"
      class="timepicker-element__underlined"
    >
      <input
        v-model="Data.mm"
        type="number"
        placeholder="mm"
        title="minutes"
        @click="selectAll"
        @change="evaluate({pointer: 'mm', min: Data.mmMin, max: Data.mmMax})"
      >
      <span>m</span>
    </span>
    <span
      v-if="isShown('ss')"
      class="timepicker-element__underlined"
    >
      <input
        v-model="Data.ss"
        type="number"
        placeholder="ss"
        title="seconds"
        @click="selectAll"
        @change="evaluate({pointer: 'ss', min: Data.ssMin, max: Data.ssMax})"
      >
      <span>s</span>
    </span>
    <!--
    <span
      class="clear"
      @click="clear">
      <font-awesome-icon :icon="['fas', 'times']" />
    </span>
    -->
  </div>
</template>

<script>

export default {
  name: 'TimepickerElement',
  components:{},
  props: {
    Data: {
      type: Object,
      default: function() {
        return{
          hh: 0,
          mm: 0,
          ss: 0,
          hhMax: 0,
          mmMax: 0,
          ssMax: 0,
          time: 0
        }
      }
    }
  },
  computed: {
    nonZero() {
      return (this.Data.hh !== 0 || this.Data.mm !== 0 || this.Data.ss !== 0)
    }
  },
  mounted() {
    this.Data.time = parseInt(this.Data.hh, 10) * 3600 + parseInt(this.Data.mm, 10) * 60 + parseInt(this.Data.ss)
    // console.debug(this.Data);
  },
  methods: {
    selectAll(e) {
      e.target.select()
    },
    isShown(name) {
      let rtn = true
      if(this.Data.hide) {
        if(this.Data.hide.indexOf(name) !== -1) {
          rtn = false
        }
      }
      return rtn
    },
    clear() {
      this.Data.hh = this.Data.mm = this.Data.ss = 0
    },
    evaluate(settings) {
      this.$nextTick(() => { // Needs delay or scroll/arrows will be one behind
        var value = this.Data[settings.pointer]
        if(!isNaN(settings.max) && this.Data[settings.pointer] > settings.max) {
          value = settings.max
        }
        if(!isNaN(settings.min) && this.Data[settings.pointer] < settings.min) {
          value = settings.min
        }
        this.Data[settings.pointer] = value

        this.Data.time = parseInt(this.Data.hh, 10) * 3600 + parseInt(this.Data.mm, 10) * 60 + parseInt(this.Data.ss)

        this.$emit('change', this.Data)
      })
    }
  }
}
</script>

<style lang="scss">
  .timepicker-element {
    display: inline-flex;
    border: 1px solid $color-grey-darker;
    padding: 5px;
    border-radius: 3px;
    background: $color-white;
    justify-content: center;
    align-items: center;

    &__underlined {
      border-bottom: 1px solid lighten($color-grey, 10);
      padding-bottom: 2px;
      margin: 0 3px;
    }

    input {
      display: inline-block;
      width: 25px;
      border: 0;
      text-align: right;
      padding: 5px 0 0;

      &[type='number'] {
        -moz-appearance:textfield;
      }

      &[type=number]::-webkit-inner-spin-button,
      &[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }

    .clear {
      $size: 15px;
      display: inline-flex;
      position: relative;
      justify-content: center;
      align-items: right;
      height: $size;
      width: $size;
      // border: 1px solid black;
      border-radius: 50%;
      font-size: 10px;
      margin-left: 10px;
      cursor: pointer;
      align-items: center;
    }
  }
</style>
